/* eslint-disable */
import * as Types from '../../../../graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetHotelRateChangeLogsQueryVariables = Types.Exact<{
  brandCode: Types.Scalars['String'];
  limit?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type GetHotelRateChangeLogsQuery = { __typename?: 'Query', getHotelRateChangeLogs?: Array<{ __typename?: 'RateChangeLog', id?: string | null, appName?: string | null, errorMessage?: string | null, brandCode?: string | null, rate?: number | null, stayDate?: any | null, updatedBy?: string | null, updatedAt?: any | null, createdAt?: any | null } | null> | null };


export const GetHotelRateChangeLogsDocument = gql`
    query GetHotelRateChangeLogs($brandCode: String!, $limit: Int) {
  getHotelRateChangeLogs(brandCode: $brandCode, limit: $limit) {
    id
    appName
    errorMessage
    brandCode
    rate
    stayDate
    updatedBy
    updatedAt
    createdAt
  }
}
    `;

/**
 * __useGetHotelRateChangeLogsQuery__
 *
 * To run a query within a React component, call `useGetHotelRateChangeLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHotelRateChangeLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHotelRateChangeLogsQuery({
 *   variables: {
 *      brandCode: // value for 'brandCode'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetHotelRateChangeLogsQuery(baseOptions: Apollo.QueryHookOptions<GetHotelRateChangeLogsQuery, GetHotelRateChangeLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHotelRateChangeLogsQuery, GetHotelRateChangeLogsQueryVariables>(GetHotelRateChangeLogsDocument, options);
      }
export function useGetHotelRateChangeLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHotelRateChangeLogsQuery, GetHotelRateChangeLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHotelRateChangeLogsQuery, GetHotelRateChangeLogsQueryVariables>(GetHotelRateChangeLogsDocument, options);
        }
export type GetHotelRateChangeLogsQueryHookResult = ReturnType<typeof useGetHotelRateChangeLogsQuery>;
export type GetHotelRateChangeLogsLazyQueryHookResult = ReturnType<typeof useGetHotelRateChangeLogsLazyQuery>;
export type GetHotelRateChangeLogsQueryResult = Apollo.QueryResult<GetHotelRateChangeLogsQuery, GetHotelRateChangeLogsQueryVariables>;
export const namedOperations = {
  Query: {
    GetHotelRateChangeLogs: 'GetHotelRateChangeLogs'
  }
}